import type {CmLogger} from "@cm/log"
import {TiledImageManagerBase} from "@cm/utils"
import {TiledImage} from "#browser-utils/tiled-image/tiled-image"

export class TiledImageManager extends TiledImageManagerBase<TiledImage> {
    // cacheInMemory defaults to false (let the browser's HTTP cache handle re-fetches instead of
    // holding every decoded tile ImageBitmap in memory indefinitely) - opt in per manager instance
    // where repeat access to the same tiles is expected and worth the memory.
    constructor(logger: CmLogger, cacheInMemory = false) {
        super((descriptor, manager) => TiledImage.create(descriptor, manager), cacheInMemory, logger)
    }
}
